import axios from 'axios'

// Use relative path /api which works with Nginx proxy in production
// In development, Vite proxy config forwards /api to backend
const API_BASE_URL = import.meta.env.VITE_API_URL || '/api'

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Helper to get current account token
const getCurrentAccountToken = (): string | null => {
  const accountsStr = localStorage.getItem('ig_accounts')
  const currentAccountId = localStorage.getItem('current_account_id')

  if (!accountsStr || !currentAccountId) {
    // Fallback to old single-token system for backward compatibility
    return localStorage.getItem('access_token')
  }

  try {
    const accounts = JSON.parse(accountsStr)
    const currentAccount = accounts.find((acc: any) => acc.id === currentAccountId)
    return currentAccount?.token || localStorage.getItem('access_token')
  } catch {
    return localStorage.getItem('access_token')
  }
}

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
  const token = getCurrentAccountToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Handle 401 responses (unauthorized)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Don't redirect if we're already on the login page or trying to login
      if (!window.location.pathname.includes('/login') && !error.config?.url?.includes('/auth/login')) {
        localStorage.removeItem('access_token')
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)
